var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarEmpty = function SvgStarEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.517,
    height: 15.517
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Star 5",
    d: "m7.718 1.115 2.165 4.313 4.57.831-3.232 3.5.66 4.827-4.163-2.155-4.161 2.152.66-4.827L.985 6.259l4.57-.831Z",
    fill: "none",
    stroke: "#707070"
  })));
};
export default SvgStarEmpty;